import * as React from "react";
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import { connect } from "react-redux";
import ActivePrescriptions from "./ActivePrescriptions";
import ArchivedPrescriptions from "./ArchivedPrescriptions";
import PharmacyHeader from "../PharmacyHeader";
import NotAuthorized from "../../common/NotAuthorized";
import * as types from "../../../constants/actionTypes";
import SectionLoading from '../../common/SectionLoading';
import SectionLoadingError from '../../common/SectionLoadingError';
import * as d from "../../../reducers/domainReducer";
import { logUI } from "../../../api/andyliticsApi";
import * as Tools from "../../../helpers/Tools";

class ViewPrescription extends React.Component {
    constructor(props) {
        super(props);
        this.state = { activeTab: '1', dataLoaded: false };
        this.loadData = this.loadData.bind(this);
        this.toggle = this.toggle.bind(this);
    }

    componentDidMount() {
        //console.log("ViewPrescriptions.componentDidMount()");
        this.loadData();
        logUI("MBHWeb.UI.Rx.ViewPrescription.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    componentWillReceiveProps() {
        //console.log("ViewPrescriptions.componentWillReceiveProps()");
    }

    shouldComponentUpdate(prevProps, prevState) {
        //console.log("ViewPrescriptions.shouldComponentUpdate()");
        return true;
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const { hasPharmacyLogin, currentPharmacyUser } = this.props;
        const patientId = currentPharmacyUser ? currentPharmacyUser.pharmacyPatientId : null;

        if (patientId && patientId !== this.patientId) {
            this.patientId = patientId;
            this.loadData();
        } else if (hasPharmacyLogin && !patientId && this.patientId !== -1) {
            this.patientId = -1;
            this.loadData();
        }
    }

    loadData() {
        const { hasPharmacyLogin, activeRxListLoaded, archivedRxListLoaded, isActiveRxListWaiting, isArchivedRxListWaiting, userDetails, isLoggedIn } = this.props;
        //if (hasPharmacyLogin && isLoggedIn && !this.state.dataLoaded) {
        //debugger;
        //this.setState({ dataLoaded: true });
        this.props.getRxListData();
        this.props.getRxArchiveListData();
        //}
        /*  if (hasPharmacyLogin && (!activeRxListLoaded) && !isActiveRxListWaiting) {
              this.props.getRxListData("");
          }
          if (hasPharmacyLogin && (!archivedRxListLoaded) && !isArchivedRxListWaiting) {
              this.props.getRxArchiveListData("");
          }*/
    }

    toggle(tab) {
        if (this.state.activeTab !== tab) {
            this.setState({ activeTab: tab });
        }
    }

    render() {

        const { hasPharmacyLogin, isActiveRxListWaiting, rxListError, activeRxList,
            isArchivedRxListWaiting, archivedRxListError, archivedRxList, userDetails, currentPharmacyUser
        } = this.props;

        const proxyUser = currentPharmacyUser && currentPharmacyUser.firstName ? currentPharmacyUser.firstName + ' has' : 'You have';

        return (
            <React.Fragment>
                {hasPharmacyLogin || (currentPharmacyUser && currentPharmacyUser.pharmacyPatientId)
                ? <div className="container-fluid body-content view-prescriptions-container">
                    <div className="row">
                        <div className="col-12 maxWidth-content">
                            <div className="row">
                                <PharmacyHeader />
                                <div className="col-12">
                                    <Nav tabs>
                                        <NavItem tabIndex="0">
                                            <NavLink className={this.state.activeTab === '1' ? 'tab-selected' : ''} onClick={() => this.toggle('1')} >
                                                ACTIVE<div className="d-none d-sm-inline"> PRESCRIPTIONS</div>
                                            </NavLink>
                                        </NavItem>
                                        <NavItem tabIndex="0">
                                            <NavLink className={this.state.activeTab === '2' ? 'tab-selected' : ''} onClick={() => this.toggle('2')}>
                                                ARCHIVED<div className="d-none d-sm-inline"> PRESCRIPTIONS</div>
                                            </NavLink>
                                        </NavItem>
                                    </Nav>

                                    <TabContent activeTab={this.state.activeTab}>
                                        <TabPane tabId="1">
                                            {typeof isActiveRxListWaiting === 'undefined' || isActiveRxListWaiting
                                                ? <SectionLoading />
                                                : !rxListError
                                                    ? activeRxList && activeRxList.length > 0
                                                        ? <ActivePrescriptions />
                                                        : <SectionLoadingError message={proxyUser + " no active prescriptions."} sectionErrorClass="no-results-error" />
                                                    : <SectionLoadingError message="We're sorry, there was an error while loading your prescriptions. Please try again later." />
                                            }

                                        </TabPane>
                                        <TabPane tabId="2">
                                            {typeof isArchivedRxListWaiting === 'undefined' || isArchivedRxListWaiting
                                                ? <SectionLoading />
                                                : !archivedRxListError
                                                    ? archivedRxList && archivedRxList.length > 0
                                                        ? <ArchivedPrescriptions />
                                                        : <SectionLoadingError message={proxyUser + " no archived prescriptions."} sectionErrorClass="no-results-error" />
                                                    : <SectionLoadingError message="We're sorry, there was an error while loading your prescriptions. Please try again later." />
                                            }
                                        </TabPane>
                                    </TabContent>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                : typeof hasPharmacyLogin !== 'undefined' && <NotAuthorized />
            }
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    //console.log("ViewPrescriptions.mapStateToProps()");
    return {
        userDetails: state.sso.userDetails,
        isLoggedIn: state.sso.isLoggedIn,
        hasPharmacyLogin: state.memberships.isActiveFeature_Pharmacy,
        isActiveRxListWaiting: state.pharmacy.isActiveRxListWaiting,
        rxListError: state.pharmacy.rxListError,
        activeRxList: state.pharmacy.activeRxList,
        isArchivedRxListWaiting: state.pharmacy.isArchivedRxListWaiting,
        archivedRxListError: state.pharmacy.archivedRxListError,
        archivedRxList: state.pharmacy.archivedRxList,
        activeRxListLoaded: state.pharmacy.activeRxListLoaded,
        archivedRxListLoaded: state.pharmacy.archivedRxListLoaded,
        currentPharmacyUser: d.hydratePharmacyUser(state.domain.cpu)
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getRxListData: () => dispatch({ type: types.LOAD_RX_LIST_START }),
        getRxArchiveListData: () => dispatch({ type: types.LOAD_ARCHIVED_RX_LIST_START })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ViewPrescription);